"use client"

import React, {useEffect, useState} from "react";
import {Alert, Snackbar} from "@mui/material";
import {useAppStore} from "@/store/AppStore";
import {Notification as NotificationType} from "@/types/Notification";

export default function Snackbars() {
  const notifications = useAppStore((state) => state.notifications);
  const removeNotification = useAppStore((state) => state.removeNotification);
  const [showNotification, setShowNotification] = useState<boolean>(false)
  const [currentNotification, setCurrentNotification] = useState<NotificationType>()

  useEffect(() => {
    const sendNotification = (info: NotificationType): void => {
      setShowNotification(true)
      setCurrentNotification(info)
    };
    if (notifications && notifications.length > 0) {
      const firstNotification = notifications[0]
      sendNotification(firstNotification)
    }
  }, [notifications, removeNotification])

  const handleClose = () => {
    setShowNotification(false)
    removeNotification(0)
  }

  return (
    <Snackbar
      anchorOrigin={{vertical: 'top', horizontal: 'center'}}
      open={showNotification}
      onClose={handleClose}
    ><Alert
      onClose={handleClose}
      severity="success"
      variant="filled"
      sx={{width: '100%'}}
    >
      <h4>{currentNotification?.title}</h4>
      {currentNotification?.message}
    </Alert></Snackbar>
  )
}
